import styled from "styled-components";
import { LayeredSquaresIcon, TrashGreenIcon } from "assets/images";
import { CustomAntCheckbox } from "components/Checkboxes/checboxStyles";
import Scrollbars from "react-custom-scrollbars-2";

interface TickerDivProps {
    readonly isSelected: boolean;
}

export const TickersSelectWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    box-shadow: 0 0 5px rgb(49 69 49 / 14%);
    overflow: auto;
    background-color: white;

    :nth-child(1) {
        border-radius: 10px 10px 10px 10px;
    }
`;

export const ModalContentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    height: 100%;
`;

export const TopElementsDiv = styled.div`
    background-color: ${(props) => props.theme.bg.grey};
    height: 45px;
    display: flex;
    flex-direction: row;
`;

export const TickersTitle = styled.div<{ isHorizontal?: boolean }>`
    display: flex;
    background-color: ${(props) => props.theme.bg.grey};
    flex-direction: column;
    padding: 8px;
    width: ${(props) => (props.isHorizontal ? "330px" : "100%")};
    .mdpSearch {
        margin-top: 11px;
    }
`;
export const ShowAllDiv = styled.div`
    display: flex;
    align-items: baseline;
    font-weight: bold;
    background-color: ${(props) => props.theme.bg.grey};
    flex-direction: row;
    line-height: initial;
`;

// export const SelectDiv = styled.div`
//     display: flex;
//     width: 100%;
//     height: calc(100% - 88px);
//     flex-direction: column;
//
// `;

export const SelectDiv = styled.div`
    //height: 100%;
    width: 100%;

    height: calc(100% - 88px);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
`;
export const ItemsWrapper = styled(Scrollbars)`
    min-width: 330px;
    height: 100% !important;
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto;
`;

export const SourceTypeDiv = styled.div`
    position: absolute;
    bottom: 4px;

    left: -0px;
`;
const DescSpan = styled.span`
    font-size: 12px;
`;
export const GraySpan = styled(DescSpan)`
    color: gray;
`;
export const GreenSpan = styled(DescSpan)`
    color: rgb(124, 190, 123);
`;
export const SettingsInfo = styled.div`
    display: flex;
    flex-direction: column;
    width: 94%;
    height: 100%;
    padding: 5px 8px 0 0;
    position: relative;
    :nth-child(-n + 2) {
        border-right: 1px solid rgba(98, 147, 97, 0.15);
    }
`;
export const RowDiv = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;

    :nth-child(1) {
        margin-bottom: 11px;
    }
`;
export const ToolLabel = styled.label`
    font-size: 14px;
    display: inline-block;
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
`;

export const IconsArea = styled.div`
    width: 35px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
`;
export const IconsWrap = styled.div`
    padding: 0 4px;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 8px;
`;
export const CustomDeleteButton = styled(TrashGreenIcon)`
    cursor: pointer;
`;

export const CustomDoubleButton = styled(LayeredSquaresIcon)`
    cursor: pointer;
`;

export const TickerItemDiv = styled.div<TickerDivProps>`
    display: flex;

    justify-content: space-between;
    align-items: center;
    height: 50px;
    padding-left: 15px;
    padding-right: 10px;
    border-bottom: 1px solid rgba(98, 147, 97, 0.15);
    background: ${(props) =>
        props["isSelected"] === true ? "rgba(98, 147, 97, 0.15)" : "white"};

    :hover {
        background: rgba(98, 147, 97, 0.15);
    }
`;

export const CustomCheckboxSmall = styled(CustomAntCheckbox)`
    margin-right: 7px;
    transform: scale(0.8);

    .ant-checkbox-checked .ant-checkbox-inner {
        background-color: white;
        border-color: rgba(124, 190, 123, 1) !important;
        border-width: 1.8px;
    }

    .ant-checkbox-checked .ant-checkbox-inner:after {
        border-color: rgba(124, 190, 123, 1) !important;
    }

    .ant-checkbox-wrapper:hover .ant-checkbox-inner,
    .ant-checkbox-checked:hover .ant-checkbox-inner,
    .ant-checkbox:hover .ant-checkbox-inner,
    .ant-checkbox-input:focus + .ant-checkbox-inner {
        border-color: rgba(124, 190, 123, 1) !important;
    }
`;

export const CustomTopCheckbox = styled(CustomAntCheckbox)`
    transform: scale(0.8);
    margin-right: 8px;

    .ant-checkbox-checked .ant-checkbox-inner {
        background-color: rgba(98, 147, 97, 1);
        border-color: rgba(98, 147, 97, 1);
        border-width: 1.8px;
    }

    .ant-checkbox-checked .ant-checkbox-inner:after {
        border-color: white !important;
        border-width: 2px;
    }

    .ant-checkbox-wrapper:hover .ant-checkbox-inner,
    .ant-checkbox-checked:hover .ant-checkbox-inner,
    .ant-checkbox:hover .ant-checkbox-inner,
    .ant-checkbox-input:focus + .ant-checkbox-inner {
        border: 1.8px solid rgba(124, 190, 123, 1) !important;
    }
`;

export const MDPSettingsBlockWrapper = styled.div<{
    isHorizontal?: boolean;
    isOpen?: boolean;
}>`
    display: flex;
    flex-direction: column;
    min-width: ${(props) =>
        props.isHorizontal && props.isOpen ? "680px" : "330px"};
    height: 100%;
`;

export const MDPParamsBlockWrapper = styled.div<{ isOpen?: boolean }>`
    width: ${(props) => (props.isOpen ? "345px" : "0")};
    // margin-right:30px;
    overflow-x: hidden;
    // border:1px solid red;
    max-width: 345px;
    flex: 0 0 auto;
    padding: 0 10px 0 5px;
    overflow: auto;
    transition:
        width 0.6s ease,
        min-width 0.3s ease;
    margin-top: -70px;
`;
